<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from "@/utils/uiWrapper";
import FooterViewOld from "./Old/FooterViewOld.vue";
import NewFooterView from "./New/NewFooterView.vue";

const current = useUiWrapper(FooterViewOld, NewFooterView);
</script>
